import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChatContainer } from './styles/ChatContainer.styles';
import { CustomChatBubbleIcon } from './styles/ChatIcons.styles';
import { ChatText } from './styles/ChatText.styles';

const EmptyChatState = () => {
  const { t } = useTranslation('chat');
  return (
    <ChatContainer optVariant="emptyChatState">
      <ChatContainer optVariant="emptyChatStateIcon">
        <CustomChatBubbleIcon />
      </ChatContainer>
      <ChatText optVariant="emptyChatTitle">
        {t('empty.title')}
      </ChatText>
      <ChatText optVariant="emptyChatDescription">
        {t('empty.description')}
      </ChatText>
    </ChatContainer>
  );
};

export default EmptyChatState;